<template>
    <div class="inputPassword flex items-center w-full">
        <div class="relative w-full">
            <input
                :name="name"
                ref="password"
                :type="active ? 'text' : 'password'"
                class="inputx w-full no_focus"
                :placeholder="placeholder"
                :value="value"
                @input="handleInput($event.target.value)"
            />
            <div
                class="show-password"
                v-tooltip="active ? $t('buttons.hidePassword') : $t('buttons.showPassword')"
                @click="showPassword"
            >
                <vs-icon
                    v-bind="$iconData(active ? 'icon-eye-off' : 'icon-eye', active ? 'fi-rr-eye-crossed' : 'fi-rr-eye')"
                    color="primary"
                    size="small"
                ></vs-icon>
            </div>
        </div>


        <vs-button
            v-if="generator"
            class="ml-2"
            type="filled"
            color="primary"
            v-bind="$iconData('icon-lock', 'fi-rr-lock')"
            @click="passwordGenerator"
            v-tooltip="$t('buttons.generatePassword')"
        ></vs-button>
    </div>
</template>

<script>
export default {
    name: 'password-input',

    props: {
        value: {
            type: String
        },
        generator: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        }
    },

    model: {
        prop: 'value',
        event: 'input'
    },

    data() {
        return {
            active: false,
            password: ''
        }
    },

    methods: {
        handleInput (event) {
            this.$emit('input', event)
        },

        passwordGenerator() {
            this.$refs.password.value = this.$generate()

            this.$emit('input', this.$refs.password.value)
            this.$emit('generate', this.$refs.password.value)
        },

        showPassword() {
            this.active = !this.active
        }
    }
}
</script>

<style lang="scss">
.inputPassword {
    .show-password {
        position: absolute;
        top: 0;
        right: 0;
        height: 39px;
        width: 39px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    input {
        border: 1px solid rgba(0, 0, 0, 0.2);
        padding: 0.7rem 39px 0.7rem 0.7rem !important;
        font-size: 1rem !important;
        color: inherit;
        position: relative;
        border-radius: 5px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        transition: all .3s ease;
        width: 100%;

        &::placeholder {
            font-size: .85rem;
            color: rgba(0,0,0,.4);
            white-space: nowrap;
            user-select: none;
            pointer-events: none;
        }
    }
}
</style>
